import { useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { setOriginalAvailableDashboards } from "../../../state/ducks";
import { dispatch } from "../../../state/store";

import { arrayUtil } from "../../../utils";
import { appManageTypes } from "../../../consts";

import { FlexContainers, Heading4, SVG, WrapperContainer } from "../../../components";
import DashboardTabHeaderControl from "./tabsHeadersControl/DashboardTabHeaderControl";
import EmailTabHeaderControl from "./tabsHeadersControl/EmailTabHeaderControl";
import { DashboardsSettingsWrapper } from "../styled";

const TabHeader = ({ title, dashboardsTitle, emailTitle, openDashboardsModal }) => {
  const selectedApp = useSelector((store) => store.apps.selectedApp);
  const manageType = useSelector((store) => store.apps.manageType);

  const originalAvailableDashboards = useSelector(
    (store) => store.apps.originalAvailableDashboards
  );

  const isOriginalAvailableDashboardsSetted = useRef(false);

  useEffect(() => {
    if (selectedApp?.availableDashboards && !isOriginalAvailableDashboardsSetted.current) {
      dispatch(setOriginalAvailableDashboards(selectedApp?.availableDashboards));
      isOriginalAvailableDashboardsSetted.current = true;
    }
  }, [selectedApp?.availableDashboards?.length]);

  const isDashboardTabHeaderControlVisible = useMemo(() => {
    return (
      manageType === appManageTypes.EDIT &&
      title === dashboardsTitle &&
      !arrayUtil.arrayEquals(
        (selectedApp?.availableDashboards || []).map((d) => `${d.name} - ${d.isSelected}`),
        originalAvailableDashboards.map((d) => `${d.name} - ${d.isSelected}`)
      )
    );
  }, [title, dashboardsTitle, originalAvailableDashboards, selectedApp]);

  const isDashboardsSettingsIconVisible = useMemo(() => {
    return (
      title === dashboardsTitle &&
      (manageType !== appManageTypes.EDIT ||
        (manageType === appManageTypes.EDIT && !isDashboardTabHeaderControlVisible))
    );
  }, [manageType, isDashboardTabHeaderControlVisible, title, dashboardsTitle]);

  const isEmailTabHeaderControlVisible = useMemo(() => {
    return manageType === appManageTypes.EDIT && title === emailTitle;
  }, [manageType, title, emailTitle]);

  return (
    <WrapperContainer
      Container={FlexContainers.FlexRowBetween}
      width="100%"
      alignItems="center"
      pr={24}>
      <Heading4>{title}</Heading4>

      {isDashboardTabHeaderControlVisible && <DashboardTabHeaderControl />}

      {isDashboardsSettingsIconVisible && (
        <DashboardsSettingsWrapper onClick={() => openDashboardsModal()}>
          <SVG.SettingsNavIcon />
        </DashboardsSettingsWrapper>
      )}

      {isEmailTabHeaderControlVisible && <EmailTabHeaderControl />}
    </WrapperContainer>
  );
};

TabHeader.propTypes = {
  title: PropTypes.string.isRequired,
  dashboardsTitle: PropTypes.string.isRequired,
  emailTitle: PropTypes.string.isRequired,
  openDashboardsModal: PropTypes.func.isRequired
};

export default TabHeader;
